import { render } from "./editTemplateProposalComponent.vue?vue&type=template&id=45b20432&scoped=true"
import script from "./editTemplateProposalComponent.vue?vue&type=script&lang=js"
export * from "./editTemplateProposalComponent.vue?vue&type=script&lang=js"

import "./editTemplateProposalComponent.vue?vue&type=style&index=0&id=45b20432&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b20432"]])

export default __exports__